var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionTabBarAdviceIconOnlyDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h35v21H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.911 5.603h-.707v7.774c0 1.21-.705 2.305-2.118 2.305H12.244v.37c0 1.07 1.217 2.15 2.467 2.15h10.583l4.05 2.38-.588-2.38h.155c1.25 0 1.813-1.078 1.813-2.15V7.448c0-1.07-.564-1.845-1.813-1.845z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.02.202H7.942C6.528.202 4.9 1.458 4.9 2.67v9.744c0 1.115 1.38 1.92 2.702 2.045l-.86 3.268 5.516-3.245H24.02c1.415 0 2.72-.858 2.72-2.068V2.67c0-1.212-1.306-2.468-2.72-2.468zM10.395 8.427a1.452 1.452 0 1 1 0-2.905 1.452 1.452 0 0 1 0 2.905zm5.425 0a1.452 1.452 0 1 1 0-2.905 1.452 1.452 0 0 1 0 2.905zm5.426 0a1.453 1.453 0 1 1 0-2.906 1.453 1.453 0 0 1 0 2.906z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionTabBarAdviceIconOnlyDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/action-tab-bar-advice-icon-only-default.3d0c67d4adc2dbf9fbb2a37ad4467cb8.svg";